import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 箱货信息
export function queryIntelligentBookingList(data) {
  return request({
    url: URL.AIdiscern.queryIntelligentDocument,
    method: 'post',
    data
  })
}
// 查询托书识别列表-高级查询
export function advancedQueryIntelligentDocument(data) {
  return request({
    url: URL.AIdiscern.advancedQueryIntelligentDocument,
    method: 'post',
    data
  })
}
// 获取附件base64
export function getPreviewJson(uuid) {
  return request({
    url: URL.AIdiscern.getPreviewJson,
    method: 'post',
    data: { uuid }
  })
}
// 获取托书解析渠道
export function queryChannelConfigFunc() {
  return request({
    url: URL.AIdiscern.queryChannelConfigUrl,
    method: 'get'
  })
}
// 获取解析渠道
export function getChannelConfigUrlFunc() {
  return request({
    url: URL.AIdiscern.getChannelConfigUrl,
    method: 'get'
  })
}
// 保存
export function saveResultJson(data) {
  return request({
    url: URL.AIdiscern.saveResultJson,
    method: 'post',
    data
  })
}
// 保存（CW-多模态识别）
export function saveResultJsonCwmi(data) {
  return request({
    url: URL.AIdiscern.saveResultJsonCwmi,
    method: 'post',
    data
  })
}
// 保存
export function saveResultJsonByFunc(data) {
  return request({
    url: URL.AIdiscern.saveResultJsonByUrl,
    method: 'post',
    data
  })
}
// 检查文件在报关单中是否上传过
export function checkAnalyseFileFunc(data) {
  return request({
    url: URL.AIdiscern.checkAnalyseFileUrl,
    method: 'post',
    data
  })
}
// 批量检查文件在报关单中是否上传过
export function batchCheckAnalyseFileFunc(data) {
  return request({
    url: URL.AIdiscern.batchCheckAnalyseFileUrl,
    method: 'post',
    data
  })
}
// 保存
export function saveResultJsonXhq(data) {
  return request({
    url: URL.AIdiscern.saveResultJsonXhq,
    method: 'post',
    data
  })
}
// 删除
export function removeIntelligentDocument(uuid) {
  return request({
    url: `${URL.AIdiscern.removeIntelligentDocument}?uuid=${uuid}`,
    method: 'post'
  })
}
// 批量删除
export function batchRemoveIntelligentDocument(data) {
  return request({
    url: `${URL.AIdiscern.batchRemoveIntelligentDocument}`,
    method: 'post',
    data
  })
}
// 查询笔云解析内容
export function queryIntelligentDocumentByFunc(uuid) {
  return request({
    url: `${URL.AIdiscern.queryDataByUrl}?uuid=${uuid}`,
    method: 'post'
  })
}
// 查询cwmi解析内容
export function queryIntelligentDocumentCwmiFunc(uuid) {
  return request({
    url: `${URL.AIdiscern.queryDataCwmiUrl}?uuid=${uuid}`,
    method: 'post'
  })
}

// 根据已上传文件解析
export function analyseFileFunc(data) {
  return request({
    url: URL.AIdiscern.analyseFileUrl,
    method: 'post',
    data
  })
}

// 复制托书记录
export function copyIntelligentDocumentFunc(data) {
  return request({
    url: URL.AIdiscern.copyIntelligentDocumentUrl,
    method: 'post',
    data
  })
}
// 获取业务 提单箱子信息
export function queryJobDataFunc(data) {
  return request({
    url: URL.AIdiscern.queryJobDataUrl,
    method: 'post',
    data
  })
}
// 覆盖系统提单
export function overrideSystemBillFunc(data) {
  return request({
    url: URL.AIdiscern.overrideSystemBillUrl,
    method: 'post',
    data
  })
}

// 上传文件解析
export function importAndAnalyseFile(formData) {
  return request({
    url: URL.AIdiscern.importAndAnalyseFile,
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 同步调用处理OCR识别
export function syncOcrByTemplateUuidWithFile(formData) {
  return request({
    url: URL.AIdiscern.syncOcrByTemplateUuidWithFile,
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 文本内容解析
export function analyseText(data) {
  return request({
    url: URL.AIdiscern.analyseText,
    method: 'post',
    data
  })
}

// 文本内容解析
export function generateScriptFunc(data) {
  return request({
    url: URL.AIdiscern.generateScriptUrl,
    method: 'post',
    data
  })
}

// 获取解析结果
export function getAnalysis(uuid) {
  return request({
    url: `${URL.AIdiscern.getAnalysis}?uuid=${uuid}`,
    method: 'get'
  })
}
